export default {
  execute(input) {
    var Parser = require('expr-eval').Parser;
    var parser = new Parser();

    // verify if input has content
    for(var prop in input) {
      if(input[prop].length==0) {
        var res = {};
        res.err = true;
        res.msg = prop + ' values missing';
        return res;
      }
    }
    // **************************************************************
    // ******************** variable declaration ********************
    
    // input data
    var criteria = clone(input.criteria);
    var actions = input.actions;
    var performanceTable = clone(input.performanceTable);
    var referenceActions = clone(input.referenceActions);
    var weights = clone(input.weights[0]);
    var thresholds = input.thresholds;
    var credibilityLevel = input.credibility;

    // initialize data
    var distanceValues = [];
    var categories = [];
    var assignedActions = [];

    // **************************************************************
    // ******************** main algorithm flow *********************

    // normalize the input weights
    normalizeWeights();

    // invert the values of criteria to minimize
    minimizeCriteria();

    // calculate the distance between actions and reference actions
    distanceReference();

    // calculate the best C(0), worst C(q+1) categories and the distance
    extentReference();

    // define the array of categories and eliminate the duplicates
    defineCategories();

    // assign the actions to the categories
    assignActions();
    
    // output
    return assignedActions;

    // **************************************************************
    // ******************** auxiliary functions *********************

    function clone(object) {
      return JSON.parse(JSON.stringify(object));
    }

    function normalizeWeights(){
      var sum = 0;
      for(var crit of criteria){
        weights[crit['Name']] = Number(weights[crit['Name']]);
        sum += weights[crit['Name']];
      }
      for(var crit of criteria){
        weights[crit['Name']] /= sum;
      }
    }

    function minimizeCriteria() {
      for(var crit of criteria) {
        if(crit['Direction'] == 'Minimization'){
          if(crit['Scale Type'] =='Cardinal'){
            var aux = crit['Min'];
            crit['Min'] = - crit['Max'];
            crit['Max'] = - aux;
          } else if(crit['Scale Type']=='Ordinal'){
            crit['Num Levels'] = - crit['Num Levels'];
          }
          for(var act of performanceTable)
            act[crit['Name']] = - act[crit['Name']];
            for(var ref of referenceActions)
            ref[crit['Name']] = - ref[crit['Name']];
        }
      }
    }

    function distanceReference() {
      for(var perf of performanceTable){
        var action = perf['Name'];
        for(var ref of referenceActions){
          var reference = ref['Name'];
          for(var crit of criteria){
            var criterion = crit['Name'];
            var distance = perf[criterion] - ref[criterion];
            distanceValues.push({'Action':action, 'Reference':reference, 
            'Value':distance, 'Criteria':criterion});
          }
        }
      }
    }
    
    function extentReference(){
      for(var crit of criteria){
        var criterion = crit['Name'];
        if(crit['Scale Type']=='Cardinal'){
          var firstValue = crit['Min'];
          var lastValue = crit['Max'];
        } else if(crit['Scale Type']=='Ordinal' && crit['Direction'] == 'Maximization'){
          var firstValue = 1;
          var lastValue = crit['Num Levels'];
          } else if(crit['Scale Type']=='Ordinal' && crit['Direction'] == 'Minimization'){
            var firstValue = crit['Num Levels'];
            var lastValue = -1;
          }
        for(var performance of performanceTable){
          var action = performance['Name'];
          var firstDistance = performance[criterion] - firstValue;
          var lastDistance = performance[criterion] - lastValue;
          distanceValues.push({'Action':action, 'Reference':'first', 
          'Value':firstDistance, 'Criteria':criterion});
          distanceValues.push({'Action':action, 'Reference':'last', 
          'Value':lastDistance, 'Criteria':criterion});
        }
      }
    }

    function partialConcordance(crit,action,reference){
      var preference = Number(thresholds[0][crit]);
      var indifference = Number(thresholds[1][crit]);
      for(var aux of distanceValues){
        if(aux['Criteria'] == crit && aux['Action'] == action && aux['Reference'] == reference){
          var value = Number(aux['Value']);
        } else if(aux['Criteria'] == crit && aux['Action'] == reference && aux['Reference'] == action){
          var value = - Number(aux['Value']);
        }
      }
        if(value >= - indifference){
          return 1;
        } else if(value >= - preference){
          return (preference + value) / (preference - indifference);
        } else return 0;
    }

    function concordanceIndex(action,reference){
      var x = 0;
      for(var crit of criteria){
        var weight = Number(weights[crit['Name']]);
        x += weight * partialConcordance(crit['Name'],action,reference);
      }
      return x;
    }
    
    function partialDiscordance(crit,action,reference){
      var preference = Number(thresholds[0][crit]);
      var veto = Number(thresholds[2][crit]);
      for(var aux of distanceValues){
        if(aux['Criteria'] == crit && aux['Action'] == action && aux['Reference'] == reference){
          var value = Number(aux['Value']);
        } else if(aux['Criteria'] == crit && aux['Action'] == reference && aux['Reference'] == action){
          var value = - Number(aux['Value']);
        }
      }
        if(value >= - preference || isNaN(veto) || veto == 0){
          return 0;
        } else if(value >= - veto){
          return (preference + value) / (preference - veto);
        } else return 1;
    }

    function credibilityIndex(action,reference){
      var prod = 1;
      var c = concordanceIndex(action,reference);
      for(var crit of criteria){
        var d = partialDiscordance(crit['Name'],action,reference);
        if(d > c){
          prod *= (1 - d) / (1 - c);
        }
      }
      return c * prod;
    }

    function categoricalIndex(x,y){
      var ans = 0;
      for(var ref of referenceActions){
        if(ref['Category'] == y){
          var credibility = credibilityIndex(x,ref['Name']);
          ans = Math.max(ans,credibility);
        } else if(ref['Category'] == x){
          var credibility = credibilityIndex(ref['Name'],y);
          ans = Math.max(ans,credibility);
        }
      }
      return ans;       
    }

    function selectingFunction(action,category){
      return Math.min(categoricalIndex(action,category),categoricalIndex(category,action));
    }

    function defineCategories(){
      categories.push('first');
      for(var ref of referenceActions){
        categories.push(ref['Category']);
      }
      categories.push('last');
      categories = Array.from(new Set(categories));
    }

    function descendingRule(action){
      var aux = categories.length;
      for(var i = 2; i <= aux; i++){
        var cat = categories[aux - i];
        var catIndex = categoricalIndex(action,cat);
        if(catIndex >= credibilityLevel){
          if(cat == categories[aux - 2]){
            return cat;
          } else if(cat == categories[0]){
            return categories[1];
          } else if(Math.min(catIndex,categoricalIndex(cat,action)) > 
          selectingFunction(action,categories[aux - i + 1])){
            return cat; 
          } else return categories[aux - i + 1];
        }
      }
    }

    function ascendingRule(action){
      var aux = categories.length;
      for(var i = 1; i < aux; i++){
        var cat = categories[i];
        var catIndex = categoricalIndex(cat,action);
        if(catIndex >= credibilityLevel){
          if(cat == categories[1]){
            return cat;
          } else if(cat == categories[aux - 1]){
              return categories[aux - 2];
          } else if(Math.min(catIndex,categoricalIndex(action,cat)) >
          selectingFunction(action,categories[i - 1])){
            return cat;
          } else return categories[i - 1];
        }
      }
    }

    function assignActions(){
      for(var action of actions){
        var name = action['Name'];
        var option1 = descendingRule(name);
        var option2 = ascendingRule(name);
        if(categories.indexOf(option1) < categories.indexOf(option2)){
          assignedActions.push({'Action':name,'Minimum':option1,'Maximum':option2});
        } else assignedActions.push({'Action':name,'Minimum':option2,'Maximum':option1});
      }
    }

  }
}


// WEBPACK FOOTER //
// ./src/services/ELECTRETRINCService.js